import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { locationItem as getLocation } from '../utils/urls';

import { Location } from 'types/locations';
import { ErrorModal } from 'types/modalTypes';

async function fetchLocation({ id, account }: TVariables): Promise<TResult> {
  if (!id)
    return new Promise((resolve, reject) => {
      reject();
    });
  const response = await fetch(getLocation(account, id), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Location | undefined;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  account: number;
  id?: number;
};

function useGetLocationInfo({
  account,
  id,
}: TVariables): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_location', account, id],
    async () => {
      if (id)
        return await fetchLocation({
          id,
          account,
        });
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetLocationInfo };
